import { BaseCol } from '@app/components/common/BaseCol/BaseCol';
import { BaseRow } from '@app/components/common/BaseRow/BaseRow';
import { PageTitle } from '@app/components/common/PageTitle/PageTitle';
import NewsForm from '@app/components/news/NewsForm';

const NewsEditPage = () => {
  return (
    <>
      <PageTitle>Cập nhật tin tức</PageTitle>
      <BaseRow gutter={[30, 30]}>
        <BaseCol xs={24} md={24} xl={24}>
          <NewsForm />
        </BaseCol>
      </BaseRow>
    </>
  );
};

export default NewsEditPage;
